module.exports = __webpack_public_path__ + "img/1F611.59489493.svg";